import { createSlice } from "@reduxjs/toolkit";
const initialVal = { value: [] };
export const versionsSlice = createSlice({
    name: "versions",
    initialState: initialVal,
    reducers: {
        setVersions: (state, action) => {
            state.value = action.payload;
        },
    },
});
export const { setVersions } = versionsSlice.actions;
export default versionsSlice.reducer;
